"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeValueHandlerAdapter_1 = require("./NodeValueHandlerAdapter");
/**
 * Converts GraphQL nulls to RDF nil terms.
 */


var NodeValueHandlerNull =
/*#__PURE__*/
function (_NodeValueHandlerAdap) {
  _inherits(NodeValueHandlerNull, _NodeValueHandlerAdap);

  function NodeValueHandlerNull(util, settings) {
    var _this;

    _classCallCheck(this, NodeValueHandlerNull);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeValueHandlerNull).call(this, 'NullValue', util, settings));
    _this.nil = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil');
    return _this;
  }

  _createClass(NodeValueHandlerNull, [{
    key: "handle",
    value: function handle(valueNode, fieldName, convertContext) {
      return {
        terms: [this.nil]
      };
    }
  }]);

  return NodeValueHandlerNull;
}(NodeValueHandlerAdapter_1.NodeValueHandlerAdapter);

exports.NodeValueHandlerNull = NodeValueHandlerNull;